// NB: tenere allineato a frontend/scripts/seo-postbuild.js (HTML servito ai crawler)
export const SEO = {
  home: {
    title: "Silvia Casali | Commercialista e controllo di gestione",
    description: "Silvia Casali e il suo team: contabilità aggiornata, pianificazione fiscale e controllo di gestione per imprese. Numeri chiari per decidere meglio.",
    keywords: "commercialista, controllo di gestione, pianificazione fiscale, contabilità, pannello direzionale, Silvia Casali, Ravenna"
  },
  forfettari: {
    title: "Contabilità per Forfettari a 43 €/mese | SC Dottori Commercialisti",
    description: "Registrazione fatture e incassi, dichiarazione dei redditi e F24 a 43 € al mese. Gestita da Dottori Commercialisti: delle annualità gestite rispondiamo noi.",
    keywords: "contabilità forfettari, commercialista forfettario, regime forfettario, dichiarazione redditi forfettario"
  },
  libro: {
    title: "Dai Numeri alle Decisioni - Il Libro di Silvia Casali",
    description: "Dai numeri alle decisioni: i quattro numeri che nessuna legge ti obbliga a calcolare. Il libro di Silvia Casali, commercialista. Su Amazon in cartaceo e Kindle.",
    keywords: "libro impresa, controllo di gestione, margine di contribuzione, punto di pareggio, Silvia Casali, dai numeri alle decisioni",
    ogImage: "https://casalisilvia.com/libro/og-libro.jpg",
    ogType: "book"
  },
  strumenti: {
    title: "Strumenti Fiscali in Excel | SC Dottori Commercialisti",
    description: "Excel e calcolatori fiscali creati da dottori commercialisti: partita IVA, forfettario, prezzi, spese deducibili. Acquisto unico, nessun abbonamento.",
    keywords: "strumenti fiscali, excel fiscale, calcolatore forfettario, simulatore partita iva, spese deducibili"
  },
  metodo: {
    title: "Il Metodo del Controllo Direzionale | SC Dottori Commercialisti",
    description: "Il metodo del controllo direzionale: leggere i numeri mentre sei in corsa, non a fine anno. Sai dove guadagni, dove perdi e quante tasse stai creando.",
    keywords: "controllo direzionale, metodo, gestione aziendale, numeri aziendali"
  },
  servizi: {
    title: "Servizi: contabilità, controllo di gestione e Pannello Direzionale | SC Dottori Commercialisti",
    description: "Tre servizi distinti e combinabili: contabilità e pianificazione fiscale, controllo di gestione e Pannello Direzionale. Numeri aggiornati per decidere meglio.",
    keywords: "servizi commercialista, adempimenti, consulenza strategica, pannello direzionale"
  },
  approfondimenti: {
    title: "Approfondimenti e Strategie | SC Dottori Commercialisti",
    description: "Bilanci di aziende vere letti da un commercialista: quanto fatturano, dove guadagnano e dove perdono. Analisi pratiche per imprenditori che vogliono capire.",
    keywords: "blog commercialista, fiscalita, controllo gestione, strategie imprenditori"
  },
  chiSiamo: {
    title: "Chi siamo: Silvia Casali e il team di SC Dottori Commercialisti",
    description: "Silvia Casali, Dottore Commercialista e Revisore Legale a Ravenna, e lo studio SC Dottori Commercialisti STP: competenze diverse coordinate al servizio delle imprese.",
    keywords: "Silvia Casali, commercialista Ravenna, STP, revisore legale, europrogettazione, controllo di gestione"
  },
  contatti: {
    title: "Contatti | SC Dottori Commercialisti",
    description: "Contatta SC Dottori Commercialisti a Ravenna, Via Ponte Marino. Telefono, email e WhatsApp. Consulenza fiscale e strategica fruibile in tutta Italia.",
    keywords: "contatti commercialista, Ravenna, consulenza gratuita"
  },
  portaleDocumenti: {
    title: "Portale Documenti | SC Dottori Commercialisti",
    description: "Il portale riservato ai clienti dello studio per caricare fatture e documenti fiscali e consultare quelli condivisi dal team, in modo semplice e sicuro.",
    keywords: "portale documenti, area clienti, caricamento documenti"
  },
  pannelloDirezionale: {
    title: "Pannello Direzionale: il cruscotto della tua azienda | SC Dottori Commercialisti",
    description: "Un cruscotto aziendale personale, aggiornato ogni mese: ricavi, costi, margini e liquidità in un unico posto. Attivabile anche se hai già un commercialista.",
    keywords: "pannello direzionale, KPI, dashboard aziendale, controllo gestione"
  },
  privacyPolicy: {
    title: "Privacy Policy | SC Dottori Commercialisti",
    description: "Informativa sulla privacy di SC Dottori Commercialisti SRL STP ai sensi del GDPR.",
    keywords: "privacy policy, GDPR, protezione dati",
    noindex: true
  },
  cookiePolicy: {
    title: "Cookie Policy | SC Dottori Commercialisti",
    description: "Informativa sull'utilizzo dei cookie di SC Dottori Commercialisti SRL STP.",
    keywords: "cookie policy, cookie, informativa",
    noindex: true
  }
};
